import { useTranslation } from "react-i18next";

import { useClientData } from "../../../../../store/client/client.selectors";

import { Item, List, SpanStyled } from "./IdentityInfo.styled";

export const IdentityInfo = () => {
  const { t } = useTranslation();
  const { anonymityInfo } = useClientData();
  const incognito = anonymityInfo?.anonymizer
    ? t("global.yes")
    : t("global.no");
  const identityData = [
    { label: "IP", value: anonymityInfo?.ip },
    { label: t("global.incognito"), value: incognito },
    { label: t("global.browser"), value: anonymityInfo?.browser },
  ];

  return (
    <List>
      {identityData.map(({ label, value }, idx) => (
        <Item key={idx}>
          <SpanStyled>{label}</SpanStyled>
          <span>{value}</span>
        </Item>
      ))}
    </List>
  );
};
